import React from "react";
import Routes from "./Routes";
import "react-toastify/dist/ReactToastify.css";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import theme from "./Hooks/themeContext";
import { ThemeProvider } from "@material-ui/core/styles";
import { ToastContainer } from "react-toastify";
import { UserContextProvider } from "./Hooks/UserContext";
import { SomaPlaceUserContextProvider } from "./Hooks/SomaPlaceContext";
import { BrowserRouter } from "react-router-dom";

const App = (props) => (
  <div className="App" style={{ height: "100vh" }}>
    <ToastContainer
      position={"bottom-center"}
      autoClose={5000}
      hideProgressBar={false}
      closeOnClick={true}
      pauseOnHover={true}
      draggable={true}
    />
    <BrowserRouter>
      <UserContextProvider>        
          <SomaPlaceUserContextProvider>
            <ThemeProvider theme={theme}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Routes />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </SomaPlaceUserContextProvider>        
      </UserContextProvider>
    </BrowserRouter>
  </div>
);

export default App;
